export { default } from './IntlProvider';
